import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { motion } from "framer-motion";
import { Smartphone, Users, Code } from "lucide-react";

export function ServicesSection() {
  const services = [
    {
      icon: Smartphone,
      title: "Digital Marketing",
      description: "Comprehensive digital advertising across all platforms",
      features: [
        "Facebook/TikTok/Google Ads",
        "App Install Campaigns", 
        "Social Content Creation",
        "Community Management",
        "KOL/KOC Marketing"
      ],
      color: "orange-600"
    },
    {
      icon: Users,
      title: "Offline & Activation",
      description: "Real-world brand activation and engagement",
      features: [
        "Workshop & Training",
        "Event Organization",
        "POSM Design & Production",
        "Roadshow Management",
        "Brand Activation"
      ],
      color: "orange-500"
    },
    {
      icon: Code,
      title: "Tech & Content Ops",
      description: "Technology solutions and content operations",
      features: [
        "A+ Content Hub Platform",
        "Custom Development",
        "Content Management System",
        "Marketing Automation",
        "Performance Analytics"
      ],
      color: "orange-700"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-orange-600">Services</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-700 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Complete 360° marketing solutions for every business need
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <Card className="h-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-0 bg-white">
                <CardHeader className="text-center pb-4">
                  <div className={`inline-flex p-4 rounded-full mb-4 mx-auto ${
                    service.color === 'orange-600' ? 'bg-orange-100' :
                    service.color === 'orange-500' ? 'bg-orange-100' : 'bg-orange-100'
                  }`}>
                    <service.icon className={`w-8 h-8 ${
                      service.color === 'orange-600' ? 'text-orange-600' :
                      service.color === 'orange-500' ? 'text-orange-500' : 'text-orange-700'
                    }`} />
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                  <p className="text-gray-600 text-lg">
                    {service.description}
                  </p>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center space-x-3">
                        <div className={`w-2 h-2 rounded-full ${
                          service.color === 'orange-600' ? 'bg-orange-600' :
                          service.color === 'orange-500' ? 'bg-orange-500' : 'bg-orange-700'
                        }`}></div>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}